














import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ClearButton",
  props: {
    state: { type: Object, required: true },
    send: { type: Function, required: true }
  },
  setup() {
    return { confirm: (message: string) => window.confirm(message) };
  }
});
